import { ReactNode } from "react";
import { ReactComponent as DefaultEmptyIcon } from "images/defaultEmptyIcon.svg";
import { Flex, Typography } from "antd";
import styles from "./customEmpty.module.css";

type Props = {
  description?: ReactNode | string;
  children?: ReactNode | string;
  icon?: ReactNode | string;
};
export const CustomEmpty = ({
  description = "Нет данных",
  icon = <DefaultEmptyIcon className={styles.defaultIcon} />,
  children,
}: Props): JSX.Element => {
  const desc = typeof description === "string" ? <Typography.Text>{description}</Typography.Text> : description;

  return (
    <Flex vertical align="center">
      {icon}
      <Flex gap="small" vertical align="center">
        {desc}
        {children}
      </Flex>
    </Flex>
  );
};
